<!--
 * @Author: your name
 * @Date: 2021-08-16 14:52:58
 * @LastEditTime: 2024-03-12 15:34:09
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\explorer\NewMediaList\NewMediaList.vue
-->
<template>
  <div class="explorer">
    <subfield>
      <template slot="list">
        <trees type="FILELIST" @getAssets="getAssets" :list="fileList" :select="`${fileId}`"></trees>
      </template>
      <template slot="content">
        <enfold-uc>
          <template slot="up">
            <div class="c-u-left">
              <div class="flex-c-c" style="margin-right: 25px;">
                <el-checkbox v-model="allFile" @change="arrSelectedFile" :indeterminate="isIndeterminate">{{$t('explorer.all')}}</el-checkbox>
              </div>
              <div>
                <popovers :content="$t('explorer.uploadFiles')">
                  <el-upload class="upload-demo" ref="upload" multiple :show-file-list="false" :accept="'image/*,video/*,audio/*'" :action="baseURL+'/admin/material/upfile'" :data="uploadFile" :before-upload="beforeUpload" :on-progress="onFileProgress" :on-success="onFileSuccess">
                    <img class="icon" src="@imgpub/public_upload.png" />
                  </el-upload>
                </popovers>
              </div>
              <div class="hover-tip" data-name="新建文件夹">
                <popovers :content="$t('explorer.newFolder')">
                  <img src="@imgpub/public_addfile.png" class="icon" @click="()=>{addFileDV = true;}" alt />
                </popovers>
              </div>
              <div class="hover-tip" data-name="删除选中文件">
                <Popovers :content="$t('explorer.deleteFiles')">
                  <img src="@imgpub/public_delete.png" class="icon" @click="()=>{delFileListDV = true;}" alt />
                </Popovers>
              </div>
              <img src="@imgpub/public_share.png" class="icon" v-show="false" alt />
              <ul class="breadcrumb flex-c-c" v-if="true">
                <li v-for="(bItem,index) in breadcrumb" :key="bItem.id" @click="breadcrumbGoto(bItem.id,bItem.group_id)">
                  <span class="breadcrumb-item">{{bItem.name}}</span>
                  <i class="breadcrumb-separator el-icon-arrow-right" v-if="index<breadcrumb.length-1"></i>
                </li>
              </ul>
            </div>
            <div class="c-u-right">
              <div style="line-height: 32px;margin: 0px 8px; color: #000;">/data/upload/</div>
              <div class="search">
                <el-input v-model="keyword" :placeholder="$t('public.search')" @focus="keyword = undefined">
                  <i slot="suffix" class="el-icon-search" @click="search(keyword)"></i>
                </el-input>
              </div>
              <div class="dir-list" v-if="false">
                <el-select v-model="dirValue" :placeholder="$t('ceni3')">
                  <!-- <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option> -->
                </el-select>
              </div>
              <div class="return-edit" v-if="$route.query.type === 'programEdit'">
                <el-button round size="mini" type="primary" @click="$router.go(-1)">{{$t('explorer.BackEdit')}}</el-button>
              </div>
              <div>
                <img src="@imgpub/public_list_sel.png" @click="listSwitch('list')" class="icon" v-if="listChart === 'list'" />
                <img src="@imgpub/public_list_nor.png" @click="listSwitch('list')" class="icon" alt v-else />
                <img src="@imgpub/public_chart_sel.png" @click="listSwitch('chart')" class="icon" v-if="listChart === 'chart'" />
                <img src="@imgpub/public_chart_nor.png" @click="listSwitch('chart')" class="icon" alt v-else />
              </div>
            </div>
          </template>
          <template slot="center" v-if="listChart === 'list'">
            <ul class="file-media-title">
              <li style="width: 50px;" class="flex-c-c">
                <el-checkbox v-model="allFile" @change="arrSelectedFile" :indeterminate="isIndeterminate"></el-checkbox>
              </li>
              <li class="flex-b-c">{{$t('explorer.name')}}</li>
              <li class="flex-b-c">{{$t('explorer.resolution')}}</li>
              <li class="flex-b-c">{{$t('explorer.fileSize')}}</li>
              <li class="flex-b-c">{{$t('explorer.creationTime')}}</li>
              <li class="flex-c-c">{{$t('explorer.operate')}}</li>
            </ul>
            <ul>
              <li v-for="(file) in fileChildList" :key="'file'+file.id">
                <file-list :file="file" :isSelected="fileSelectList.findIndex(id => id === file.id) > -1" @setFileGroupId="setFileGroupId" @setFileName="setFileName" @setDeleteFile="setDeleteFile" @setFileMoveId="setFileMoveId" @setSelectFile="setSelectFile"></file-list>
              </li>
            </ul>
            <ul>
              <li v-for="(media,index) in mediaList" :key="'media-' + media.key">
                <media-list :media="media" :isSelected="mediaSelectList.findIndex(id=>id === media.id) > -1" @setSelectMedia="setSelectMedia" @setDeleteMedia="setDeleteMedia" @setMediaMoveId="setMediaMoveId" @openMedia="handlePreview (index, media)"></media-list>
              </li>
              <li class="loading-media flex-c-c" @click="mediaLoad">
                <span>{{mediaList.length === current?$t('explorer.materialAll'):$t('explorer.materialsLoaded')}}</span>
              </li>
            </ul>
          </template>
          <template slot="center" v-else>
            <ul class="file-list">
              <li class="file-chile" :style="{'pointer-events': pointerEvent?'none':'auto'}" @click="pointerEvents">
                <el-upload class="upload-demo" ref="upload" drag multiple :show-file-list="false" :accept="'image/*,video/*,audio/*,.zip'" :action="baseURL+'/admin/material/upfile'" :data="uploadFile" :before-upload="beforeUpload" :on-progress="onFileProgress" :on-success="onFileSuccess">
                  <el-popover placement="right-start" width="200" trigger="hover">
                    <div>
                      <p>
                        <span style="font-weight: bold;">{{$t('explorer.picture')}}:</span>
                        bmp/jpg/png/gif,{{$t('explorer.sizeLimit')}}10M
                      </p>
                      <p>
                        <span style="font-weight: bold;">{{$t('explorer.video')}}:</span>
                        AVI/WMV/MPG/RM/RMVB/MOV/DAT/VOB/MP4/FLV,{{$t('explorer.sizeLimit')}}2G
                      </p>
                    </div>
                    <div slot="reference">
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text" style="user-select: none;" v-html="$t('explorer.clickUpload')"></div>
                    </div>
                  </el-popover>
                </el-upload>
              </li>
              <li class="file-chile" v-for="(file) in fileChildList" :key="'file'+file.id">
                <file-item :file="file" :isSelected="fileSelectList.findIndex(id => id === file.id) > -1" @setFileGroupId="setFileGroupId" @setFileName="setFileName" @setDeleteFile="setDeleteFile" @setFileMoveId="setFileMoveId" @setSelectFile="setSelectFile"></file-item>
              </li>
              <i v-for="index in 12" :key="'file-i-'+index" style="width: 120px; margin: 0px 4px;"></i>
            </ul>
            <ul class="media-list" v-infinite-scroll="mediaLoad" :infinite-scroll-immediate="false" :infinite-scroll-delay="500">
              <li v-for="(media,index) in mediaList" :key="'media-' + media.key" class="media-chile" @dblclick="handlePreview (index, media)">
                <media-item :media="media" :isSelected="mediaSelectList.findIndex(id=>id === media.id) > -1" @setSelectMedia="setSelectMedia" @setDeleteMedia="setDeleteMedia" @setMediaMoveId="setMediaMoveId" @setDescribe="setDescribe"></media-item>
              </li>
              <li class="media-chile media-chile-load flex-c-c" @click="mediaLoad">
                <span>{{mediaList.length === current?$t('explorer.materialAll'):$t('explorer.materialsLoaded')}}</span>
              </li>
              <i v-for="index in 12" :key="'media-i-'+index" style="width: 20%; max-width: 240px; height: 0px; margin: 0px 4px;"></i>
            </ul>
          </template>
        </enfold-uc>
      </template>
    </subfield>
    <div class="download">
      <div class="download-info">
        <transition name="download">
          <div class="download-icon" v-show="!isShowDownload">
            <img src="@/assets/images/public/public_news.png" alt @click="isShowDownload = true" />
          </div>
        </transition>
        <transition name="download">
          <div class="download-list" v-show="isShowDownload">
            <download-list :mediaUpList="mediaUpList" @retransmission="retransmission" @cancelupload="cancelupload" @allCancelupload="allCancelupload" @uploadPause="uploadPause" @uploadPlay="uploadPlay" @allUploadPlay="allUploadPlay" @allUploadPause="allUploadPause" @clearAllSuccess="clearAllSuccess" @isShowDownloadList="isShowDownloadList"></download-list>
          </div>
        </transition>
      </div>
    </div>
    <preview :previewData="previewData" @previewVisible="previewVisible"></preview>
    <form-dialog :dialogVisible="addFileDV" @closeDialog="addFileCD" :title="$t('explorer.newFolder')">
      <div class="form-dialog">
        <el-form :model="addFile" :rules="rules" ref="fileForm" label-width="100px">
          <div class="form-item">
            <el-form-item :label="$t('explorer.newFolder')" prop="fileName">
              <el-input v-model="addFile.fileName" style="width: 250px;"></el-input>
            </el-form-item>
          </div>
          <el-form-item>
            <el-button @click="resetForm('FolderName')" round>{{$t('basics.Cancel')}}</el-button>
            <el-button type="primary" @click="submitForm('fileForm')" round>{{$t('basics.Confirm')}}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </form-dialog>
    <msg-dialog :dialogVisible="setTargetDV" @closeDialog="setTargetCD" :title="$t(moveCopy)">
      <div class="file-move">
        <el-tree node-key="id" highlight-current :auto-expand-parent="false" :data="fileTree" :props="defaultProps" :default-expanded-keys="[1]" @node-click="handleNodeClick"></el-tree>
      </div>
    </msg-dialog>
    <del-dialog :dialogVisible="delFileListDV" @closeDialog="delFileListCD" :title="$t('explorer.deleteFiles')">
      <div style="text-align: center;">{{$t('explorer.deleteFiles')}}</div>
    </del-dialog>
    <msg-dialog :dialogVisible="setDescribeDV" @closeDialog="setDescribeCD" :title="$t('ceni4')">
      <el-input type="textarea" :rows="4" :placeholder="$t('ceni5')" v-model="mediaDescribe.text"></el-input>
    </msg-dialog>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import trees from '@/components/basics/Trees'
import EnfoldUc from '@/components/basics/EnfoldUC'
import MediaItem from './MediaItem.vue'
import MediaList from './MediaList.vue'
import FileItem from './FileItem.vue'
import FileList from './FileList.vue'
import DownloadList from './DownloadList.vue'
import Preview from '@/components/basics/Preview'
import {
  mPreview,
  mPagination
} from "@/components/basics/mixins"
import {
  handleDataAndSign
} from "@/assets/scripts/handleDataAndSign";
import {
  getFileChild,
  getBreadcrumb
} from "@/assets/scripts/publicFunction";
//  getOrganization,
// getGroupBreadcrumb
// import Utils from "@/assets/scripts/Utils";
import FormDialog from '@/components/basics/FormDialog'
import MsgDialog from '@/components/basics/MsgDialog'
import DelDialog from '@/components/basics/DelDialog'
import superClone from "@/assets/scripts/superClone";
// import { getChildrenIds } from "@/assets/scripts/publicFunction";
import Popovers from "@/components/basics/Popover";
import JSZip from 'jszip';
// import XLSX from 'js-xlsx';

export default {
  name: 'NewMediaList',
  mixins: [mPagination, mPreview],
  data() {
    return {
      groupList: [],
      mediaList: [],
      fileList: [],
      fileChildList: [],
      baseURL: '/api',
      dirValue: "",
      uploadFile: {},
      mediaUpList: [],
      allFile: false,
      isIndeterminate: false,
      breadcrumb: [],
      fileId: 1,
      addFileDV: false,
      listChart: "chart",
      moveCopy: "explorer.FileMove",
      addFile: {
        fileName: ""
      },
      rules: {
        // 表单验证
        fileName: [{
          required: true,
          message: '请输入文件夹名称',
          trigger: 'blur'
        }]
      },
      setTargetDV: false,
      setDescribeDV: false,
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      fileMove: {
        fileId: -1,
        targetId: -1,
      },
      mediaMove: {
        mediaId: -1,
        targetId: -1,
      },
      mediaDescribe: {
        id: -1,
        text: "",
      },
      fileSelectList: [],
      mediaSelectList: [],
      operationType: "",
      delFileListDV: false,
      fileTree: [],
      mediaLoading: true,
      isShowDownload: false,
      downloadTimeoutId: null,
      pointerEvent: false,
    }
  },
  async created() {
    // await this.$http.post("/admin/access/dirInit", {}, () => {});
    await this.getMdList();
    await (this.fileId = this.fileList[0].id);
    await this.initFileList();
  },
  methods: {
    listSwitch(val) {
      this.listChart = val;
    },
    arrSelectedFile(bool) {
      this.fileSelectList = [];
      this.mediaSelectList = [];
      if (bool) {
        this.fileChildList.forEach(file => {
          file.group_dir === 0 && this.fileSelectList.push(file.id);
        });
        this.mediaList.forEach(media => {
          this.mediaSelectList.push(media.id);
        });
      }
    },
    // 添加文件夹
    addFileCD() {
      this.addFileDV = false;
      this.addFile.fileName = "";
    },
    submitForm(fileForm) {
      this.$refs[fileForm].validate((valid) => {
        if (valid) {
          this.$http.post("/admin/material/addMd", {
            group_id: this.groupId,
            pid: this.fileId,
            name: this.addFile.fileName
          }, async () => {
            this.addFileDV = false;
            await this.getMdList();
            await this.initFileList();
          })
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(fileForm) {
      this.addFileDV = false;
      this.$refs[fileForm].resetFields();
    },
    setTargetCD(config) {
      if (config) {
        if (this.operationType === "move") {
          if (this.fileSelectList.length > 0) {
            this.setFileMove(this.fileSelectList.join(","));
          } else if (this.fileMove.fileId > 0) {
            this.setFileMove(this.fileMove.fileId);
          }
          if (this.mediaSelectList.length > 0) {
            this.setMediaMove(this.mediaSelectList.join(","));
          } else if (this.mediaMove.mediaId > 0) {
            this.setMediaMove(this.mediaMove.mediaId);
          }
        }
        if (this.operationType === "copy") {
          if (this.fileSelectList.length > 0) {
            this.setFileCopy(this.fileSelectList.join(","));
          } else if (this.fileMove.fileId > 0) {
            this.setFileCopy(this.fileMove.fileId);
          }
          if (this.mediaSelectList.length > 0) {
            this.setMediaCopy(this.mediaSelectList.join(","));
          } else if (this.mediaMove.mediaId > 0) {
            this.setMediaCopy(this.mediaMove.mediaId);
          }
        }
      }
      this.setTargetDV = false;
    },
    //移动文件与媒体
    setFileMove(dir_ids) {
      this.$http.post("/admin/material/mMd", {
        dir_ids,
        targetdir_id: this.fileMove.targetId
      }, async () => {
        await this.getMdList();
        await this.initFileList();
      })
    },
    setMediaMove(mids) {
      this.$http.post("/admin/material/mvm", {
        mids,
        targetdir_id: this.mediaMove.targetId
      }, async () => {
        await this.getMdList();
        await this.initFileList();
      })
    },
    // 复制文件与媒体
    setFileCopy(dir_ids) {
      this.$http.post("/admin/material/cpMd", {
        dir_ids,
        targetdir_id: this.fileMove.targetId
      }, async () => {
        await this.getMdList();
        await this.initFileList();
      })
    },
    setMediaCopy(mids) {
      this.$http.post("/admin/material/cpm", {
        mids,
        targetdir_id: this.mediaMove.targetId
      }, async () => {
        await this.getMdList();
        await this.initFileList();
      })
    },
    // 修改文件夹名称
    setFileName(id, name) {
      this.$http.post("/admin/material/editMd", {
        id,
        name
      }, async () => {
        await this.getMdList();
        await this.initFileList();
      })
    },
    // 设置移动文件夹id
    setFileMoveId(id, type) {
      this.moveCopy = "explorer.File" + (type === "copy" ? "Copy" : "Move");
      this.operationType = type;
      this.fileMove.fileId = id;
      this.setTargetDV = true;
      this.setFileTree(this.fileList, id)
    },
    // 设置移动文件id
    setMediaMoveId(id, type) {
      this.moveCopy = "explorer.File" + (type === "copy" ? "Copy" : "Move");
      this.operationType = type;
      this.mediaMove.mediaId = id;
      this.setTargetDV = true;
      this.setFileTree(this.fileList, id)
    },
    // 修改媒体描述
    setDescribe(id, describe) {
      this.mediaDescribe.text = describe;
      this.mediaDescribe.id = id;
      this.setDescribeDV = true;
    },
    // 移动目标节点
    handleNodeClick(data) {
      this.fileMove.targetId = data.id;
      this.mediaMove.targetId = data.id;
    },
    // 文件删除
    setDeleteFile(dir_ids) {
      this.$http.post("/admin/material/delMd", {
        dir_ids
      }, async () => {
        await this.getMdList();
        await this.initFileList();
      })
    },
    // 素材删除
    setDeleteMedia(mids) {
      this.$http.post("/admin/material/delM", {
        mids
      }, async () => {
        await this.getMdList();
        await this.initFileList();
      })
    },
    // 删除列表
    delFileListCD(config) {
      if (config) {
        this.fileSelectList.length > 0 && this.setDeleteFile(this.fileSelectList.join(","));
        this.mediaSelectList.length > 0 && this.setDeleteMedia(this.mediaSelectList.join(","));
      }
      this.delFileListDV = false;
    },
    setDescribeCD(config) {
      if (config) {
        const { id, text } = this.mediaDescribe
        this.$http.post("/admin/material/editDescribe", { mid: id, describe: text }, async () => {
          await this.getMdList();
          await this.initFileList();
        })
      }
      this.setDescribeDV = false;
    },
    setSelectMedia(bool, mid) {
      if (bool) {
        this.mediaSelectList.push(mid);
      } else {
        let index = this.mediaSelectList.findIndex(fileId => fileId === mid);
        this.mediaSelectList.splice(index, 1);
      }
      this.allSelectStatus();
    },
    setSelectFile(bool, fid) {
      if (bool) {
        this.fileSelectList.push(fid);
      } else {
        let index = this.fileSelectList.findIndex(fileId => fileId === fid);
        this.fileSelectList.splice(index, 1);
      }
      this.allSelectStatus();
    },
    allSelectStatus() {
      let sFile = this.fileChildList.filter(file => file.group_dir === 0);
      if (this.fileSelectList.length === 0 && this.mediaSelectList.length === 0) {
        this.allFile = false;
        this.isIndeterminate = false;
      } else if (this.fileSelectList.length === sFile.length && this.mediaSelectList.length === this.mediaList
        .length) {
        this.allFile = true;
        this.isIndeterminate = false;
      } else {
        this.allFile = false;
        this.isIndeterminate = true;
      }
    },
    // 文件列表初始化
    initFileList() {
      this.breadcrumb = getBreadcrumb(this.fileList, this.fileId).reverse();
      this.fileChildList = getFileChild(this.fileList, this.fileId);
      this.getFileMedia(this.fileId);
    },
    setFileTree(fileList, id) {
      if (id < 0) {
        return;
      }
      this.fileTree = superClone(fileList);
      this.getFileTree(this.fileTree, id);
    },
    getFileTree(fileList, id) {
      for (let i = 0; i < fileList.length; i++) {
        if (fileList[i].id == id) {
          fileList.splice(i, 1);
          return true;
        } else if (fileList[i].child.length > 0) {
          if (this.getFileTree(fileList[i].child, id)) {
            return true;
          }
        }
      }
      return false;
    },
    // 组织结构切换目录
    getAssets(ids) {
      if (ids.type === "FILELIST") {
        this.groupId = ids.groupId;
        this.fileId = ids.id;
        this.initFileList();
      }
    },
    // 文件列表切换目录
    setFileGroupId(groupId, fileId) {
      this.groupId = groupId;
      this.fileId = fileId;
      this.initFileList();
    },
    // 面包屑切换目录
    breadcrumbGoto(fileId, groupId) {
      this.groupId = groupId;
      this.fileId = fileId;
      this.initFileList();
    },
    search(keyword) {
      this.keyword = keyword;
      this.getFileMedia();
      this.keyword = "";
    },
    mediaLoad() {
      setTimeout(() => {
        if (this.mediaList.length < this.current) {
          this.page += 1;
          this.getNewMediaList();
        }
      }, 500);
    },
    getFileMedia() {
      this.page = 1;
      this.current = 0;
      this.mediaList = [];
      this.getNewMediaList();
    },
    async getNewMediaList(media = {
      dir_id: this.fileId,
      limit: this.limit,
      page: this.page,
      key_word: this.keyword
    }) {
      if (media.page === 1) { this.mediaList = []; }
      await this.$http.post("/admin/material/list", media, data => {
        if (data.data && data.data.length > 0) {
          this.mediaList = this.mediaList.concat(data.data);
          this.mediaList.forEach(media => {
            media['key'] = Math.random();
          });
          // this.mediaList = data.data;
          this.current = data.total;
        } else {
          // this.$msg({ showClose: true, message: '已加载全部资源！', type: 'warning' });
        }
      });
    },
    async getMdList() {
      await this.$http.post("/admin/material/mdList", {}, data => {
        this.fileList = data;
      })
      this.fileSelectList = []; //文件选择清空
      this.mediaSelectList = []; // 媒体先择清空
      this.fileMove.fileId = -1; // 
      this.mediaMove.mediaId = -1;
      this.allFile = false;
      this.isIndeterminate = false;
    },
    // getMediaList(media = {
    //   limit: this.limit,
    //   group_ids: this.groupIds,
    //   dir_id: this.dirId,
    //   page: this.page,
    // }) {
    //   console.log(media);
    //   this.$http.post("/admin/material/list", media, data => {
    //     if (data.list && data.list.length > 0) {
    //       this.mediaList = this.mediaList.concat(data.list);
    //       this.page += 1;
    //       this.current = data.count;
    //     } else {
    //       // this.$msg({ showClose: true, message: '已加载全部资源！', type: 'warning' });
    //     }
    //   });
    // },
    async getZipFile(file) {
      let zipFile = {};
      await JSZip.loadAsync(file).then(async (res) => {
        let filesNmae = {};
        for (let key in res.files) {
          if (/\.(xml)$/.test(key)) { filesNmae.xml = key; }
          if (/\.(JPG)$/.test(key)) { filesNmae.jpg = key; }
        }
        await res.file(res.files[filesNmae.xml].name).async('string')
          .then(content => {
            let xml = content.match(/<DataContent>[\s\S]*<\/DataContent>/)[0].
              replace(/<DataContent><!\[CDATA\[/, '').
              replace(/\]\]><\/DataContent>/, '');
            zipFile.xml = xml.split('\n').slice(2, 5).join('');
            filesNmae.name = xml.split('\n')[1];
          })

        await res.file(res.files[filesNmae.jpg].name).async('blob')
          .then(content => {
            zipFile.img = new File(
              [content],
              filesNmae.name.trim() + '.JPG',
              { type: "image/jpeg", lastModified: Date.now() }
            );
          })
      });
      return zipFile;
    },
    // **********素材上传 START***********
    // 上传文件之前的钩子
    // eslint-disable-next-line no-unused-vars
    async beforeUpload(file) {
      let zipFile = {};
      let formData = {};
      const { type } = file;
      formData.dir_id = this.fileId;
      formData.group_id = this.groupId;
      if (type === "application/x-zip-compressed") {
        zipFile = await this.getZipFile(file);
        formData.describe = zipFile.xml;
      }
      formData.type = this.fileSwitch(type);
      let data = handleDataAndSign("/admin/material/upfile", formData);
      this.uploadFile = { ...this.uploadFile, ...data };

      this.downloadTimeoutId && clearTimeout(this.downloadTimeoutId);
      this.isShowDownload = true;
      this.downloadTimeoutId = setTimeout(() => {
        this.isShowDownload = false;
      }, 5000);

      if (type === "application/x-zip-compressed") {
        return new Promise((resolve) => {
          resolve(zipFile.img);
        })
      }
    },
    fileSwitch(type) {
      let key = type.split('/')[0];
      switch (key) {
        case 'video':
          return 1;
        case 'image':
          return 2;
        case 'audio':
          return 6;
        default:
          return 2;
      }
      // this.upTileType = { '1': '视频', '2': '图片', '6': '音乐' }[this.fileType];
      // this.acceptType = { '1': 'video/*', '2': 'image/*', '6': 'audio/*' }[this.fileType];
    },
    // 文件上传时的钩子
    onFileProgress(event, file, fileList) {
      this.mediaUpList = fileList
      // console.log(this.mediaUpList);
    },
    // 文件上传成功时的钩子
    onFileSuccess(response, file, fileList) {
      // console.log(response, file, fileList);
      if (response.status != 1) {
        this.$msg({
          showClose: true,
          message: response.tips,
          type: 'warning'
        });
        return;
      }
      // this.handleUploadParam(response);
      if (fileList.every((tiem) => {
        return tiem.response
      })) {
        this.getFileMedia();
        console.log("全部上传完成！");
      }
    },
    pointerEvents() {
      this.pointerEvent = true;
      setTimeout(() => {
        this.pointerEvent = false;
      }, 2000);
    },
    // 将上传的文件写到数据库
    // handleUploadParam(response) {
    //   console.log(response);
    //   let uploadParam = {
    //     type: this.fileType,
    //     group_id: this.groupId,
    //     dir_id: this.dirId,
    //     fids: response.data.id,
    //     names: response.data.name,
    //     urls: encodeURIComponent(response.data.url)
    //   };
    //   this.$http.post("/admin/material/add", uploadParam, data => {
    //     console.log(data);
    //   });
    // },
    // 重传当前暂停文件
    retransmission(index) {
      if (this.mediaUpList[index].status !== "ready") {
        this.mediaUpList[index].status = "ready";
        this.$refs.upload.submit();
      }
    },
    // 删除当前上传文件
    cancelupload(index) {
      this.$refs.upload.abort(this.mediaUpList[index]);
      this.mediaUpList.splice(index, 1);
    },
    // 暂停当前上传文件
    uploadPause(index) {
      let file = this.mediaUpList[index]
      this.$refs.upload.abort(file);
      file.status !== "ready" && file.status !== 'success' ? file.status = 'stop' : 0;
    },
    // 开始当前上传文件
    uploadPlay(index) {
      let file = this.mediaUpList[index]
      file.status === 'stop' ? file.status = "ready" : 0;
      this.$refs.upload.submit();
    },
    // 暂停所有上传文件
    allUploadPause() {
      this.mediaUpList.forEach((file) => {
        this.$refs.upload.abort(file);
        file.status !== "ready" && file.status !== 'success' ? file.status = 'stop' : 0;
      });
    },
    // 开始所有上传文件
    allUploadPlay() {
      this.mediaUpList.forEach((file) => {
        file.status === 'stop' ? file.status = "ready" : 0;
      });
      this.$refs.upload.submit();
    },
    // 取消全部上传
    allCancelupload() {
      this.mediaUpList.forEach((file, index) => {
        if (file.status !== 'success') {
          this.$refs.upload.abort(file);
          this.mediaUpList.splice(index, 1);
        }
      });
    },
    // 清除所有上传完成文件
    clearAllSuccess() {
      while (this.mediaUpList.filter(file => file.status === 'success').length > 0) {
        this.mediaUpList.forEach((file, index) => {
          if (file.status === 'success') {
            this.$refs.upload.abort(file);
            this.mediaUpList.splice(index, 1);
          }
        });
      }
    },
    // 隐藏上传列表
    isShowDownloadList() {
      this.isShowDownload = false;
    }
    // **********素材上传 END***********
  },
  computed: {
    // groupIdList() {
    //   let self = this;
    //   let data = Utils.MSDataTransfer.treeToArray(
    //     self.groupList,
    //     null,
    //     null,
    //     self.defaultExpandAll
    //   );
    //   return data;
    // },
    // isSelectedFile: () => (fileId) => {
    //   return this.fileSelectList.findIndex(id => id === fileId) > 0;
    // }
    // isSelectedFile() {
    //   return (fileId) => {
    //     return this.fileSelectList.findIndex(id => id === fileId) > -1;
    //   }
    // }
  },
  watch: {
    'mediaUpList.length': {
      handler(nVal, oVal) {
        console.log(nVal, oVal);
      }
    }
  },
  components: {
    subfield,
    trees,
    EnfoldUc,
    FileItem,
    MediaItem,
    DownloadList,
    Preview,
    FormDialog,
    MsgDialog,
    DelDialog,
    Popovers,
    MediaList,
    FileList
  }
}
</script>

<style lang="scss" scoped>
.explorer {
  width: 100%;
  height: 100%;

  .c-u-left {
    display: flex;

    .hover-tip {
      position: relative;
      transition: all 300ms;
      // &::before,
      // &::after {
      //   position: absolute;
      //   left: calc(50% - 12px);
      //   bottom: 80%;
      //   opacity: 0;
      //   transform: translate3d(0, -30px, 0);
      //   transition: all 300ms;
      // }
      // &::before {
      //   margin: 0 0 12px -35px;
      //   border-radius: 5px;
      //   width: 100px;
      //   height: 30px;
      //   background-color: rgba(#000, 0.5);
      //   line-height: 30px;
      //   text-align: center;
      //   color: #fff;
      //   font-size: 14px;
      //   content: attr(data-name);
      // }
      // &::after {
      //   margin-left: -6px;
      //   border: 6px solid transparent;
      //   border-top-color: rgba(#000, 0.5);
      //   width: 0;
      //   height: 0;
      //   content: "";
      // }
      // &:hover {
      //   &::before,
      //   &::after {
      //     opacity: 1;
      //     transform: translate3d(0, 0, 0);
      //   }
      // }
    }

    .el-button {
      margin-left: 10px;
    }

    .breadcrumb {
      line-height: 30px;

      .breadcrumb-item {
        // font-weight: 700;
        color: #606266;
        font-size: 16px;
        cursor: pointer;
      }

      .breadcrumb-item:hover {
        // filter: blur(1px);
        color: #2fb3ff;
      }

      .breadcrumb-separator {
        margin: 0 4px;
        font-weight: 400;
        color: #c0c4cc;
      }
    }

    .icon {
      width: 30px;
      height: 30px;
      margin-right: 25px;
    }
  }

  .c-u-right {
    display: flex;

    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
    }

    /deep/ .el-input__suffix {
      line-height: 30px;
      color: #2fb3ff;
      font-size: 16px;
      right: 10px;
    }

    .search {
      width: 180px;
      // margin-right: 25px;
    }

    .dir-list {
      width: 140px;

      /deep/ .el-input__icon {
        line-height: 30px;
      }
    }

    .return-edit {
      margin-left: 25px;

      /deep/ .el-button--mini {
        padding: 8px 15px;
      }
    }
    .icon {
      width: 30px;
      height: 30px;
      margin-left: 25px;
    }
  }
  .file-media-title {
    display: flex;
    justify-content: space-between;
    height: 26px;
    padding: 12px 0;
    li {
      width: calc(20% - 10px);
      font-size: 18px;
      color: #2fb3ff;
    }
    li:nth-child(2) {
      width: calc(20%);
    }
    li:last-child {
      width: calc(20% - 20px);
    }
  }
  .loading-media {
    height: 40px;
    background-color: #eefbff;
    border: 2px solid #fff;
    cursor: pointer;
  }
  // 文件列表样式
  .file-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .file-chile {
      cursor: pointer;
      width: 120px;
      height: 120px;
      border-radius: 4px;
      overflow: hidden;
      margin: 4px;

      /deep/ .el-upload-dragger {
        width: 120px;
        height: 120px;
        .el-icon-upload {
          font-size: 67px;
          color: #c0c4cc;
          margin: 10px 0 16px;
          line-height: 50px;
        }
      }
    }

    .file-chile:hover {
      background-color: #eefbff;
    }
  }

  // 多媒体列表样式
  .media-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .media-chile {
      width: 20%;
      max-width: 240px;
      border-radius: 4px;
      overflow: hidden;
      margin: 4px;
      cursor: pointer;
    }

    .media-chile-load {
      background-color: #eefbff;
      user-select: none;
      width: 20%;
      max-width: 240px;
      padding-top: calc(11.2%);
      position: relative;
      span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        white-space: nowrap;
      }
    }

    .media-chile:hover {
      background-color: #eefbff;
    }
  }

  .operation {
    display: flex;
    justify-content: space-around;
    align-items: center;
    .icon {
      margin: 0px;
    }
  }

  .download {
    position: fixed;
    right: 16px;
    bottom: 16px;
    // padding: 4px;
    border-radius: 8px;

    .download-info {
      position: relative;

      .download-enter-active {
        transition: opacity 1s;
      }

      .download-leave-active {
        transition: opacity 1s;
      }

      .download-enter,
      .download-leave-to {
        opacity: 0;
      }

      .download-list {
        top: 0px;
        left: 0px;
        width: 400px;
        height: 300px;
        border-radius: 8px;
        // display: none;
        overflow: hidden;
        border: 6px solid #eefbff;
      }

      .download-icon {
        position: absolute;
        bottom: 0px;
        right: 0px;
        width: 30px;
        height: 30px;
        cursor: pointer;
        background-color: #24b7f5;
        border-radius: 20px;
        padding: 5px;

        &:hover {
          background-color: rgba($color: #24b7f5, $alpha: 0.5);
        }

        img {
          width: 30px;
          height: 30px;
        }
      }

      // .download-icon:hover + .download-list {
      //   display: block;
      // }
      // .download-list:hover {
      //   display: block;
      // }
    }
  }

  .msg-dialog {
    /deep/ .md-content {
      .form-dialog {
        padding-right: 0px;

        .form-item {
          padding-bottom: 22px;
          padding-right: 30px;
        }
      }
    }

    .file-move {
      height: 200px;
      overflow: auto;
    }
  }
}
</style>
